import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Grid2,
    TextField,
    SelectChangeEvent,
    Checkbox,
    FormControlLabel,
} from '@mui/material';
import React, { ChangeEvent, ReactElement, useEffect } from 'react';
import { RootState } from '../../../../redux/reducers';
import {
    createNewEmptyProject,
    importProjectsForSiteForm,
    selectProject,
    toggleCreateNewProject,
    updateProjectName,
} from '../../../../redux/actions/siteActions';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { isEmployeeProjectManager, isEmployeeWarehouseManager } from '../../../../redux/selectors/employeeSelector';

type ProjectFormStepProps = {
    isRequired: boolean;
};

export default function ProjectFormStep(props: ProjectFormStepProps): ReactElement {
    const { isRequired } = props;

    const project = useAppSelector((state: RootState) => state.site.project);
    const createNewProject = useAppSelector((state: RootState) => state.site.createNewProject);
    const selectedProjectId = useAppSelector((state: RootState) => state.site.newProjectId);
    const isNewClientCreated = useAppSelector((state: RootState) => state.site.createNewClient);

    const selectedClient = useAppSelector((state: RootState) => state.site.newClientId);

    const projects = useAppSelector((state: RootState) => state.site.projects);

    const isProjectManager = useAppSelector(isEmployeeProjectManager);
    const isWarehouseManager = useAppSelector(isEmployeeWarehouseManager);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!project) {
            dispatch(createNewEmptyProject());
        }
    }, [dispatch]);

    useEffect(() => {
        if (!!selectedClient && selectedClient > 0) {
            dispatch(importProjectsForSiteForm(selectedClient));
        }
    }, [dispatch, selectedClient]);

    const handleToggleCreateNewProject = () => {
        dispatch(toggleCreateNewProject());
    };

    const handleInputElementChange = (event: ChangeEvent<HTMLInputElement>) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        switch (name) {
            case 'name':
                dispatch(updateProjectName(value));
                break;
            default:
                console.log('%cERROR', 'color: red');
        }
    };

    const handleSelectProject = (event: SelectChangeEvent<number>) => {
        const value = event.target.value;

        if (!isNaN(+value) && +value > 0) {
            dispatch(selectProject(+value));
        }
    };

    return (
        <Box>
            {isProjectManager && (
                <FormControlLabel
                    disabled={isNewClientCreated}
                    label="Kreiraj novi projekat"
                    control={
                        <Checkbox
                            checked={createNewProject || isNewClientCreated}
                            onChange={handleToggleCreateNewProject}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    }
                />
            )}

            {(!createNewProject && !isNewClientCreated) || (isWarehouseManager && !isProjectManager) ? (
                <Box>
                    <FormControl fullWidth required={isRequired} error={isRequired && !selectedProjectId}>
                        <InputLabel id="demo-simple-select-label">Projekat</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            type="number"
                            value={selectedProjectId ?? ''}
                            label="Projekat"
                            onChange={handleSelectProject}
                        >
                            {projects?.map((currProject) => {
                                return (
                                    <MenuItem
                                        key={(currProject?.id ?? Math.random()) + (currProject?.name ?? '')}
                                        value={currProject.id}
                                    >
                                        {currProject.name}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </Box>
            ) : (
                <Box>
                    <Grid2 container spacing={2} style={{ maxWidth: '700px', margin: 'auto' }}>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                            <TextField
                                error={!project?.name || project?.name === ''}
                                required
                                fullWidth
                                name="name"
                                label="Naziv"
                                value={!!project?.name ? project?.name : ''}
                                variant="outlined"
                                onChange={handleInputElementChange}
                            />
                        </Grid2>
                    </Grid2>
                </Box>
            )}
        </Box>
    );
}
